export default "__VITE_ASSET__DrZLeBRJ__"